import angular from "angular";

angular
    .module('app')
    .component('fieldsControl', {
        template: require('./fields-control.html'),
        controller: ['$http', 'notifier', '$timeout', '$uibModal', controller],
        bindings: {
        }
    });

function controller($http, notifier, $timeout, $uibModal) {

    const $ctrl = this;

    $ctrl.page = 1;
    
    $ctrl.perPage = 20;

    $ctrl.search = '';

    $ctrl.$onInit = () => {
        $ctrl.getList();
    };

    $ctrl.getList = () => {
        $http
            .get(`/control-panel/fields/get-list`, {
                params: {
                    page: $ctrl.page,
                    search: $ctrl.search,
                }
            })
            .then(res => {
                $ctrl.fields = res.data.data;
                $ctrl.total = res.data.total;
            });
    };

    $ctrl.filter = () => {
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.openForm = (field) => {
        $uibModal
            .open({
                component: 'fieldForm',
                resolve: {
                    field() {
                        return field
                    }
                }
            })
            .result
            .then(res => {
                $ctrl.getList();
            });
    };

    $ctrl.delField = (field, ind) => {
        if (confirm('Вы действительно хотите удалить данное поле?')) {
            $http
                .post(`/control-panel/fields/${field.id}`, {_method: 'DELETE'})
                .then(res => {
                    $ctrl.fields.splice(ind, 1);
                    notifier.successNotify('Успешно удалено', 2000);
                })
                .catch(err => {
                    notifier.errorResponseNotify(err);
                });
        }
    };
}


// WEBPACK FOOTER //
// ./resources/assets/modules/components/fields-control/fields-control.js